import { useShoppingCartEffect } from '../../../effects/common/shopping-cart.effect';

export const usePromoBoxEffect = () => {
  const { addCartProductVariant } = useShoppingCartEffect();

  const addPromoProductToCart = (variantId: number, quantity: number) => {
    addCartProductVariant(variantId, quantity);
  };

  return {
    addPromoProductToCart,
  };
};
